import { Col, Row } from "antd/es/grid";
import { Header as AntHeader } from "antd/es/layout/layout";
import './Header.css'
import { CSSProperties } from "react";
const Header: React.FC<{ CustomHeader?: any, customHeaderProps?: CSSProperties }> = (params) =>
(<AntHeader className="nav">
    <Row style={{ height: "100%" }} >
        <Col xs={0} md={8} style={{ height: "100%" }} >
            <div className="logo">
                <a href="/">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/logo/minvoice-horizontal.png`}></img>
                </a>

            </div>
        </Col>
        <Col xs={24} md={16} style={{ ...params.customHeaderProps }}>
            <params.CustomHeader />
        </Col>
    </Row>
</AntHeader >)
export default Header